import { MousePointerClick } from 'lucide-react';
import { useOpenAuthDialog } from '@/components/Modals/AuthDialog/useOpenAuthDialog';
import { Button, Text } from '@music-vine/cadence/ui';

/**
 * The free plan, deemphasized to a banner below the paid plan cards for the
 * Business tier launch (DEV-6399). Logged-out only — its caller decides.
 */
export const FreePlanBanner = () => {
  const openAuthDialog = useOpenAuthDialog();
  return <div className="flex flex-col items-start gap-4 rounded-xl border border-gray-150 border-solid bg-white p-6 sm:flex-row sm:items-center dark:border-gray-800 dark:bg-gray-950" data-sentry-component="FreePlanBanner" data-sentry-source-file="FreePlanBanner.tsx">
      <div className="flex-1">
        <Text asChild className="mb-0.5 flex items-start gap-1 font-semibold text-base text-gray-950 sm:text-xl dark:text-white" data-sentry-element="Text" data-sentry-source-file="FreePlanBanner.tsx">
          <h3>
            {/* mt centres the icon on the first line rather than on the
                whole heading, which drifts once it wraps (DEV-6728). */}
            <MousePointerClick className="size-6 shrink-0 sm:mt-1" data-sentry-element="MousePointerClick" data-sentry-source-file="FreePlanBanner.tsx" />
            Start with a free account
          </h3>
        </Text>
        <Text className="text-pretty text-gray-700 text-sm dark:text-gray-400" data-sentry-element="Text" data-sentry-source-file="FreePlanBanner.tsx">
          Get 3 free downloads for individual use on your own channels.
        </Text>
      </div>
      <Button border className="border-black hover:border-black dark:border-white dark:hover:border-white" onClick={() => openAuthDialog({
      context: 'pricing-free-plan'
    })} size="lg" variant="transparent" data-sentry-element="Button" data-sentry-source-file="FreePlanBanner.tsx">
        Start free
      </Button>
    </div>;
};